class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
  }

  connectedCallback() {
    const megaMenu = this.querySelector('.mega-menu');
    const details = this.querySelector('details');

    if (megaMenu) {
      const button = megaMenu.querySelector('.mega-menu__button');
      if (!button?.nextElementSibling) return;
      this.mainDetailsToggle = megaMenu;
      this.content = button.nextElementSibling;
    } else if (details) {
      const summary = details.querySelector('summary');
      if (!summary?.nextElementSibling) return;
      this.mainDetailsToggle = details;
      this.content = summary.nextElementSibling;
    } else {
      return;
    }

    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    this.header = document.querySelector('.header-wrapper');
    this.searchInput = this.querySelector('.search__input');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.mainDetailsToggle.hasAttribute('open')) {
      if (this.searchInput) trapFocus(this, this.searchInput);
    } else {
    }

    // START custom: update is-header-menu-open class
    const isAnyOpen = !!this.header.querySelectorAll('.mega-menu[open]').length;
    this.header.classList.toggle('is-header-menu-open', isAnyOpen);
    document.body.classList.toggle('is-header-menu-open', isAnyOpen);
    // END custom: update is-header-menu-open class

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
